module.exports = __webpack_public_path__ + "media/audio4.d5e602b8.mp3";